import React from 'react'
import { Panel, Container, CheckBoxField, Label, TextField, Toolbar, Button, TextAreaField, FieldSet, ComboBoxField, Image, DateField, NumberField } from "@sencha/ext-modern"
import GroupCheckBox from 'tyan/components/GroupCheckBox'
import GroupRadioField from "tyan/components/GroupRadioField"
import { connect } from 'react-redux'
import { compose } from 'redux'
import Message from 'tyan/components/Message'
import { doGetDailyTask, doSaveDailyTask, doDelDailyTask } from 'tyan/reducers/actions'
import 'tyan/css/DetalApproval.css';
import TreeListView from 'tyan/components/TreeListView'
import { showFile, getFileIcon } from 'tyan/public/index'
import Dialog from 'tyan/components/Dialog'
import { WX, getUrl } from 'tyan/public'
import { nullDate, equalFuns, reconfigButton } from 'tyan/public/utility'
// import Form from '../public/components/Form'
Ext.require('Ext.MessageBox')
const style = {
  outer: {
    backgroundColor: "#f5f5f5",
    padding: "10px",
  },
  innerContainer: {
    borderRadius: "10px",
    backgroundColor: "#ffffff",
    padding: "10px",
    width: "100%",
  },
  titleContainer: {
    borderBottom: "1px solid #f5f5f5",
  },
}
class DailyTaskStatus extends React.Component {
  state = {
    contract: null,
    errorMessage: null,
    changeValues: {},
    testResult: null,
    contractMessage: null,
    path: '',
    showDialog: false,
  }

  componentDidMount() {
    const { doGetDailyTask, match: { params: { dailyTaskID } } } = this.props
    doGetDailyTask({
      dailyTaskID,
      onEnd: ({ dailyTask, errorMessage }) => {
        this.setState({ dailyTask, errorMessage })
      }
    })
  }

  isEqual = (value1, value2) => (JSON.stringify(Array.isArray(value1) && value1.sort() || value1) === JSON.stringify(Array.isArray(value2) && value2.sort() || value2))

  handleBack = () => {
    const { history, match: { params: { source } } } = this.props
    Ext.toast(`执行成功！`)
    history.goBack()
  }

  handleSubmit = (dailyTaskID, type) => {
    const { doSaveDailyTask, doDelDailyTask } = this.props
    const { changeValues, testResult } = this.state
    let itype = 0
    if (type == "转发") {
      itype = 1
    }
    if (type == "已处理") {
      itype = 2
    }
    if (type == "完成") {
      itype = 3
    }
    if (type == "转发" || type == "完成" || type == "已处理") {
      doSaveDailyTask({
        dailyTaskID: dailyTaskID,
        changeValues,
        testResult,
        onEnd: ({ dailyTaskNewID, errorMessage }) => {
          if (errorMessage) {
            this.setState({ errorMessage })
          } else {
            location.hash = `/QYWX/DailyTaskInfo/${dailyTaskNewID}/${itype}`
          }
        }
      })
    }
    if (type == "保存") {
      doSaveDailyTask({
        dailyTaskID: dailyTaskID,
        changeValues,
        testResult,
        onEnd: ({ errorMessage }) => {
          if (errorMessage) {
            this.setState({ errorMessage })
          } else {
            if (dailyTaskID == -1) {
              window.close()
            }
            else {
              this.handleBack()
            }
          }
        }
      })
    }
    if (type == "删除") {
      doDelDailyTask({
        dailyTaskID: dailyTaskID,
        onEnd: ({ errorMessage }) => {
          if (errorMessage) {
            this.setState({ errorMessage })
          } else {
            this.handleBack()
          }
        }
      })
    }
  }


  //文本控件
  inputRender = ({ item, level }) => {
    return <TextField key={item.name}
      labelAlign="left"
      labelWidth="auto"
      margin={"0 0 0 " + (level * 28)}
      label={"<font color='black'>" + item.name + "：</font>" || null}
      name={item.name}
      value={item.value}
      width="100%"
      onChange={(obj, value) => this.handlerInputChange({ name: item.name, value })}
    />
  }
  handlerInputChange = ({ name, value }) => {
    const { changeValues } = this.state
    if (!this.isEqual(value, changeValues[name])) {
      this.setState({ changeValues: { ...changeValues, [name]: value } })
    }
  }
  //多行文本控件
  textareaRender = ({ item, level }) => {
    return <TextAreaField key={item.name}
      labelAlign="left"
      labelWidth="auto"
      margin={"0 0 0 " + (level * 28)}
      label={"<font color='black'>" + item.name + "：</font>" || null}
      name={item.name}
      value={item.value}
      width="100%"
      onChange={(obj, value) => this.handlertextareaChange({ name: item.name, value })}
    />
  }
  handlertextareaChange = ({ name, value }) => {
    const { changeValues } = this.state
    if (!this.isEqual(value, changeValues[name])) {
      this.setState({ changeValues: { ...changeValues, [name]: value } })
    }
  }
  //日期控件
  dateRender = ({ item, level }) => {
    const d = item.value && item.value !== nullDate && new Date(item.value) || null
    const value = d && new Date(d.getFullYear(), d.getMonth(), d.getDate())
    return <DateField key={item.name}
      labelAlign="left"
      margin={"0 0 0 " + (level * 28)}
      label={"<font color='black'>" + item.name + "：</font>" || null}
      labelWidth="auto"
      name={item.name}
      value={value}
      width="100%"
      noLocale='false'
      onChange={(obj, value) => this.handlerDateChange({ name: item.name, value })} />
  }
  handlerDateChange = ({ name, value }) => {
    const { changeValues } = this.state
    const newValue = value && Date.UTC(value.getFullYear(), value.getMonth(), value.getDate()).valueOf()
    if (!this.isEqual(newValue, changeValues[name])) {
      this.setState({ changeValues: { ...changeValues, [name]: newValue } })
    }
  }

  //复选控件
  checkboxRender = ({ item, level }) => {
    return <GroupCheckBox key={item.name}
      margin={"0 0 0 " + (level * 28)}
      label={item.name + "：" || null}
      options={item.options}
      onCheck={obj => {
        const checked = obj.getChecked()
        const option = obj.getBoxLabel()
        const value = item.value && [...item.value] || []
        const index = value.indexOf(option)
        checked && index === -1 && value.push(option)
        !checked && index >= 0 && value.splice(index, 1)
        this.handlerInputChange({ name: item.name, value })
      }}
      checked={item.value}
    />
  }

  //单选控件
  radioRender = ({ item, level, }) => {
    return <GroupRadioField key={item.name}
      margin={"0 0 0 " + (level * 28)}
      label={item.name + "：" || null}
      options={item.options}
      onCheck={obj => this.handlerInputChange({ name: item.name, value: obj.getBoxLabel() })}
      name={item.name}
      checked={item.value}
      width="100%"
    />
  }
  //下拉控件
  dropdownlistRender = ({ item, level }) => {
    return <ComboBoxField key={item.name}
      labelAlign="left"
      labelWidth="auto"
      margin={"0 0 0 " + (level * 28)}
      label={"<font color='black'>" + item.name + "：</font>" || null}
      options={item.options}
      onChange={(obj, value) => this.handlerInputChange({ name: item.name, value })}
      name={item.name}
      value={item.value}
      width="100%"
    />
  }

  //数字控件
  numberRender = ({ item, level }) => {
    return <NumberField key={item.name}
      labelAlign="left"
      label={"<font color='black'>" + item.name + "：</font>" || null}
      labelWidth="auto"
      name={item.name}
      value={item.value}
      width="100%"
      onChange={(obj, value) => this.handlerInputChange({ name: item.name, value })}
    />
  }

  //附件控件
  uploadRender = ({ item, level, testResult }) => {
    return (<FieldSet key={item.name} title={item.name} labelWidth="auto" width="100%">
      <Container layout={{ type: 'vbox', pack: 'start' }} key={item.name}>
        {testResult[item.name] && testResult[item.name].map((photo, index) => (
          <Container key={'c_' + index} layout={{ type: 'hbox', align: "start", pack: "space-between" }} >
            <Button key={item.name + '_' + index} ui="confirm round" text={'附件' + (index + 1)} textAlign="left" handler={() => this.setState({ showDialog: true, path: photo.file })} />
            <i key={'i_' + index} style={style.delete} className={"fa fa-trash"} onClick={() => {
              Ext.Msg.show({
                title: "警告", message: "确定要删除吗？",
                buttons: [{ itemId: "ok", text: "确定" }, { itemId: "cancel", text: "取消" }],
                fn: buttonID => buttonID == "ok" && this.handleDeleteImage(testResult, index)
              })
            }}></i>
          </Container>
        ))}
      </Container>
      <Container layout={{ type: 'vbox', align: 'right' }}>
        <Button margin={"0 0 0 " + (level * 28)} ui="" text="拍照" margin="0 10 0 0" handler={() => this.handleChooseImage(testResult)} />
      </Container>
    </FieldSet>
    )
  }

  handleChooseImage = (testResult) => {
    this.setState({ testResult: testResult })
    WX.chooseImage({
      onChoosed: ({ file, serverId }) => {
        const { testResult } = this.state
        !testResult && (testResult = {})
        !testResult.附件 && (testResult.附件 = [])
        const testResultNew = { ...testResult, 附件: [...testResult.附件, { file: file, serverId: serverId }] }
        this.setState({ testResult: testResultNew })
      }
    })
  }

  handleDeleteImage = (testResult, index) => {
    testResult.附件.splice(index, 1)
    const testResultNew = { ...testResult, 附件: [...testResult.附件] }
    this.setState({ testResult: testResultNew })
  }

  imageDialog = () => {
    const { path, showDialog } = this.state
    return (
      <Dialog
        displayed={showDialog}
        title="图片查看"
        maximizable
        bodyPadding="20"
        maxWidth="200"
        scrollable
        style='max-height: calc(100vh - 210px); overflow-y: auto;'
        defaultFocus="#ok"
        html=''
      >
        <Image mode="" src={getUrl(path)} width="100%" height="auto" scrollable />
        <Button text={'关闭'} handler={() => this.setState({ showDialog: false })} />
      </Dialog>
    )
  }

  showdailyTask = (dailyTask, testResult) => {
    return (
      <Container layout={{ type: "vbox", align: "left" }} style={style.innerContainer} padding="0" >
        {dailyTask && dailyTask.基本信息.map((item, index) => {
          switch (item.type) {
            case "attachment":
              return (
                <Container key={index} layout={{ type: 'hbox', pack: 'start' }}>
                  <Label cls="label" key={index} html={item.name + '：'} padding="12 0 12 0" />
                  <Button ui="confirm round" iconCls={"x-fa fa-file-" + getFileIcon('.' + item.ext)} cls="file-button" text="详情..." height="80%" handler={() => showFile({ path: item.path, ext: item.ext })} />
                </ Container>)
            case "tree":
              return (
                <TreeListView key={item.name} data={item.children} />)
            case "logs":
              return (
                <Container layout={{ type: 'vbox', pack: 'start' }} key={index}>
                  <Label cls="label" key={index} html={item.name + '：'} />
                  {item.list && item.list.map((o, i) => (
                    <Label style={style.titleContainer} cls="label" key={i} html={o.content} padding="8 0 0 0" />
                  ))}
                </Container>
              )
            case "attachmentList":
              return (
                <Container layout={{ type: 'hbox', pack: 'start' }} key={index}>
                  <Label cls="label" key={index} html={item.name + '：'} />
                  <Container layout={{ type: 'vbox', pack: 'start', }} padding="0 0 0 10" >
                    {item.list && item.list.map((o, i) => (
                      <Container key={i} layout={{ type: 'vbox', pack: 'start', }} width="100%" padding="0 0 0 0" >
                        <Button ui="confirm round" iconCls={"x-fa fa-file-" + getFileIcon('.' + o.ext)} cls="file-button" text={o.file} height="80%" handler={() => showFile({ path: o.path, ext: o.ext })} />
                      </ Container>
                    )
                    )}
                  </ Container>
                </Container>
              )
            case "input":
              return (this.inputRender({ item: item, level: 0 }))
            case "textarea":
              return (this.textareaRender({ item: item, level: 0 }))
            case "date":
              return (this.dateRender({ item: item, level: 0 }))
            case "checkbox":
              return (this.checkboxRender({ item: item, level: 0 }))
            case "radio":
              return (this.radioRender({ item: item, level: 0 }))
            case "dropdownlist":
              return (this.dropdownlistRender({ item: item, level: 0 }))
            case "number":
              return (this.numberRender({ item: item, level: 0 }))
            case "upload":
              return (this.uploadRender({ item: item, level: 0, testResult }))
            default:
              return (<Label cls="label" key={index} html={item.name + '：' + item.value} padding="0 0 0 0" />)
          }
        })}
      </ Container>
    )
  }

  getTestResult = () => {
    const { dailyTask, testResult } = this.state
    var newtestResultOld = testResult
    if (!testResult) {
      dailyTask && dailyTask.基本信息.map((item, index) => {
        switch (item.type) {
          case "upload":
            newtestResultOld = { 附件: item.value }
            break
        }
      })
    }
    return { ...newtestResultOld }
  }

  render() {
    const { dailyTask, errorMessage } = this.state
    if (errorMessage) {
      return <Message text="错误" subtext={errorMessage} />
    } else if (!dailyTask) {
      return <Message text="数据加载中..." />
    }
    const panelProps = {
      height: "100%",
      margin: '0 0 0 0',
      padding: '0 0 0 0'
    }
    const testResult = this.getTestResult()
    if (dailyTask.status == 1) {
      if (dailyTask.dailyTaskID == -1) {
        return (
          <Panel shadow layout="vbox" {...panelProps}>
            <Container layout="vbox" flex={4} scrollable style={style.outer}>
              {this.showdailyTask(dailyTask, testResult)}
            </Container>
            <Toolbar shadow={false} docked="bottom" layout={{ type: 'hbox', pack: 'right' }}>
              <Button ui="action raised" text="转发" margin="0 10 0 0" handler={() => { this.handleSubmit(dailyTask.dailyTaskID, '转发') }} />
              <Button ui="action raised" text="保存" margin="0 10 0 0" handler={() => { this.handleSubmit(dailyTask.dailyTaskID, '保存') }} />
            </Toolbar>
            {this.imageDialog()}
          </Panel>
        )
      }
      else {
        return (
          <Panel shadow layout="vbox" {...panelProps}>
            <Container layout="vbox" flex={4} scrollable style={style.outer}>
              {this.showdailyTask(dailyTask, testResult)}
            </Container>
            <Toolbar shadow={false} docked="bottom" layout={{ type: 'hbox', pack: 'right' }}>
              <Button ui="action raised" text="转发" margin="0 10 0 0" handler={() => { this.handleSubmit(dailyTask.dailyTaskID, '转发') }} />
              <Button ui="action raised" text="保存" margin="0 10 0 0" handler={() => { this.handleSubmit(dailyTask.dailyTaskID, '保存') }} />
              <Button ui="action raised" text="删除" margin="0 10 0 0" handler={() => Ext.Msg.show({
                title: "删除确认", message: "确定要删除吗？",
                buttons: [{ itemId: "ok", text: "确定" }, { itemId: "cancel", text: "取消" }],
                fn: buttonID => buttonID == "ok" && this.handleSubmit(dailyTask.dailyTaskID, '删除')
              })} />
            </Toolbar>
            {this.imageDialog()}
          </Panel>
        )
      }
    }
    else if (dailyTask.status == 2) {
      return (
        <Panel shadow layout="vbox" {...panelProps}>
          <Container layout="vbox" flex={4} scrollable style={style.outer}>
            {this.showdailyTask(dailyTask, testResult)}
          </Container>
          <Toolbar shadow={false} docked="bottom" layout={{ type: 'hbox', pack: 'right' }}>
            <Button ui="action raised" text="已处理" margin="0 10 0 0" handler={() => { this.handleSubmit(dailyTask.dailyTaskID, '已处理') }} />
            <Button ui="action raised" text="转发" margin="0 10 0 0" handler={() => { this.handleSubmit(dailyTask.dailyTaskID, '转发') }} />
          </Toolbar>
          {this.imageDialog()}
        </Panel>
      )
    }
    else if (dailyTask.status == 3) {
      return (
        <Panel shadow layout="vbox" {...panelProps}>
          <Container layout="vbox" flex={4} scrollable style={style.outer}>
            {this.showdailyTask(dailyTask, testResult)}
          </Container>
          <Toolbar shadow={false} docked="bottom" layout={{ type: 'hbox', pack: 'right' }}>
            <Button ui="action raised" text="完成" margin="0 10 0 0" handler={() => { this.handleSubmit(dailyTask.dailyTaskID, '完成') }} />
            <Button ui="action raised" text="转发" margin="0 10 0 0" handler={() => { this.handleSubmit(dailyTask.dailyTaskID, '转发') }} />
          </Toolbar>
          {this.imageDialog()}
        </Panel>
      )
    }
    else {
      return (
        <Panel shadow layout="vbox" {...panelProps}>
          <Container layout="vbox" flex={4} scrollable style={style.outer}>
            {this.showdailyTask(dailyTask, testResult)}
          </Container>
          <Toolbar shadow={false} docked="bottom" layout={{ type: 'hbox', pack: 'right' }}>
            <Button ui="action raised" text="转发" margin="0 10 0 0" handler={() => { this.handleSubmit(dailyTask.dailyTaskID, '转发') }} />
          </Toolbar>
          {this.imageDialog()}
        </Panel>
      )
    }
  }
}

const mapStateToProps = ({ }) => ({})

export default compose(
  connect(mapStateToProps, { doGetDailyTask, doSaveDailyTask, doDelDailyTask })
)(DailyTaskStatus)